/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    ModalDialog = require('./modalDialog'),
    ImagesUpload = require('./imagesUpload'),
    Table = require('./table'),
    //
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        name: 'imagesEditor',
        class: 'imagesEditor'
    },
    childViewEvents: {
        'edit:delete':     'onEditDelete',
        'edit:save':       'onEditSave',
        'move:down':       'onMoveDown',
        'move:up':         'onMoveUp',
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    regions: {
        table: {el: 'div[name=table]', replaceElement: true},
        imagesUpload: {el: 'div[name=imagesUpload]', replaceElement: true}
    },
    events: {
        'click button': 'onClickButton'
    },
    tagName: 'div',
    template: templates.imagesEditor,
    initialize: function () {
        this.collection = this.options.images;
        this.programId = this.options.programId;
        // console.log('imagesEditor.initialize - programId:%s', this.programId);
    },
    onAttach: function () {
        this.showChildView('imagesUpload', new ImagesUpload({programId: this.programId, collection: this.collection, modalModal: true}));
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        switch (action) {
            case 'upload':
                // console.log('imagesEditor.upload');
                // this.imagesUpload = new ImagesUpload({programId: this.programId, collection: this.collection, modalModal: true});
                break;
            default:
                break;
        }
        return action ? false : true;
    },
    onEditDelete: function (imageId) {
        let image = this.collection.get(imageId);
        this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'imageLabel', name: image.attributes.originalFileName}, modalModal: true});
        this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
            this.collection.remove(image);
            image.destroy();
            image = null;
        }, this));
    },
    onEditSave: function (serializedArray) {
        this.collection.update(serializedArray);
    },
    onMoveDown: function (modelId) {
        this.collection.moveDown(modelId);
    },
    onMoveUp: function (modelId) {
        this.collection.moveUp(modelId);
    },
    onRender: function () {
        this.showChildView('table', new Table({title: null, collection: this.collection, emptyMessage: 'noImagesLabel'}));
        // _.defer(_.bind(function () {
        //     this.showChildView('imagesUpload', new ImagesUpload({programId: this.programId, collection: this.collection, modalModal: true}));
        // }, this));
    }
});
